import VueClickAway from 'vue3-click-away'
import { boot } from 'quasar/wrappers'

export default boot(({ app }) => {
  app.use(VueClickAway)
})
